export default __webpack_public_path__ + "static/media/elearningpng.c45a8876.png";